import { render, staticRenderFns } from "./DriversFieldsOverview.vue?vue&type=template&id=6aaea248&scoped=true&"
import script from "./DriversFieldsOverview.vue?vue&type=script&lang=js&"
export * from "./DriversFieldsOverview.vue?vue&type=script&lang=js&"
import style0 from "./DriversFieldsOverview.vue?vue&type=style&index=0&id=6aaea248&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaea248",
  null
  
)

export default component.exports